/*
 * Changes:
 * - Added 'use client' directive for Next.js 13+ compatibility
 * - File contains client-side features: React hooks, Jotai state management, and API queries
 */

'use client'

import {useAtomValue, useSetAtom} from 'jotai'
import {currentUserState, isAuthenticatedState, oauthCredentialsState, snackbarMessagesState} from '@frnt/base/atoms'
import {useCurrentUserQuery} from '../users-service-provider'
import {useQueueSnackbarMessage} from '@frnt/base/hooks'

const CurrentUserProvider = ({children}) => {
  const oauthCredentials = useAtomValue(oauthCredentialsState)
  const isAuthenticated = useAtomValue(isAuthenticatedState)
  const setCurrentUser = useSetAtom(currentUserState)
  const queueSnackbarMessage = useQueueSnackbarMessage(snackbarMessagesState)

  useCurrentUserQuery({
    accessToken: oauthCredentials.accessToken,
    enabled: isAuthenticated,
    onSuccess: (data) => {
      setCurrentUser(data)
    },
    onError: (e) => {
      console.error('[CurrentUserProvider] User fetch ERROR:', {
        error: e,
        message: e?.message,
        responseData: e?.response?.data,
        status: e?.response?.status
      })
      queueSnackbarMessage({
        title: `Could not get current user: ${e?.response?.data?.message || e.message}`
      })
    }
  })

  return children
}

export {CurrentUserProvider}
